import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#fcfbfd]" data-testid="forgot-page">
      <div className="w-full max-w-md animate-fade-up">
        <Link to="/login" className="inline-flex items-center text-sm text-[#7248ae] hover:text-[#3e166c] mb-8" data-testid="back-to-login-link">
          <ArrowLeft className="h-4 w-4 mr-2" />Volver
        </Link>

        <p className="text-xs uppercase tracking-[0.3em] text-[#7248ae] mb-3">Recuperar acceso</p>
        <h1 className="font-display text-4xl font-black text-[#1a0f2e] mb-3 tracking-tight">¿Olvidaste tu contraseña?</h1>

        {!sent ? (
          <>
            <p className="text-[#7248ae] mb-8">Te enviaremos un link mágico para crear una nueva contraseña.</p>
            <form onSubmit={onSubmit} className="space-y-5" data-testid="forgot-form">
              <div>
                <Label htmlFor="email" className="text-xs uppercase tracking-wider text-[#7248ae] mb-2 block">Correo</Label>
                <Input
                  id="email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
                  placeholder="tu@correo.com"
                  data-testid="forgot-email-input"
                  className="h-12 border-[#b182ec]/50 focus:border-[#3e166c] focus:ring-2 focus:ring-[#b182ec]/30 rounded-xl"
                />
              </div>
              <Button type="submit" disabled={loading} data-testid="forgot-submit-button"
                className="w-full h-12 rounded-xl bg-[#3e166c] hover:bg-[#7248ae] text-white">
                {loading ? "Enviando…" : (<><Mail className="mr-2 h-5 w-5" />Enviar link</>)}
              </Button>
            </form>
          </>
        ) : (
          <div className="p-6 rounded-2xl bg-[#3e166c]/5 border border-[#b182ec]/30" data-testid="forgot-success">
            <div className="w-12 h-12 rounded-full bg-[#3e166c] flex items-center justify-center mb-4">
              <Mail className="h-6 w-6 text-white" />
            </div>
            <h3 className="font-display text-xl font-bold text-[#1a0f2e] mb-2">Revisa tu correo</h3>
            <p className="text-[#7248ae]">Si <strong className="text-[#1a0f2e]">{email}</strong> está registrado, te enviamos un link de recuperación. Expira en 1 hora.</p>
          </div>
        )}
      </div>
    </div>
  );
}
